(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personasqueancomprado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var TAG_NAME = 'live-viewers-counter';
    var READY_CLASS = 'is-ready';
    var COUNT_SELECTOR = '[data-live-viewers-count]';
    var IDLE_TIMEOUT = 1500;
    var IDLE_FALLBACK_DELAY = 600;

    function toInt(value, fallback) {
      var parsed = parseInt(value, 10);
      return isFinite(parsed) ? parsed : fallback;
    }

    function randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function scheduleIdle(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT });
        return;
      }

      window.setTimeout(callback, IDLE_FALLBACK_DELAY);
    }

    function afterPageLoad(callback) {
      if (document.readyState === 'complete') {
        scheduleIdle(callback);
        return;
      }

      window.addEventListener('load', function () {
        scheduleIdle(callback);
      }, { once: true });
    }

    function revealStaticCounters() {
      var counters = document.querySelectorAll(TAG_NAME);

      for (var i = 0; i < counters.length; i += 1) {
        counters[i].classList.add(READY_CLASS);
      }
    }

    function defineCounter() {
      if (!('customElements' in window)) {
        revealStaticCounters();
        return;
      }

      if (customElements.get(TAG_NAME)) {
        return;
      }

      class LiveViewersCounter extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.countEl = this.querySelector(COUNT_SELECTOR);

          if (!this.countEl) {
            this.classList.add(READY_CLASS);
            return;
          }

          this.min = Math.max(1, toInt(this.dataset.minViewers, 18));
          this.max = Math.max(this.min, toInt(this.dataset.maxViewers, 44));
          this.updateMin = Math.max(15000, toInt(this.dataset.updateMin, 20000));
          this.updateMax = Math.max(this.updateMin, toInt(this.dataset.updateMax, 35000));
          this.maxUpdates = Math.max(0, toInt(this.dataset.maxUpdates, 2));
          this.variation = Math.min(3, this.max - this.min);
          this.current = randomInt(this.min, this.max);
          this.updates = 0;
          this.timer = 0;
          this.visible = false;
          this.active = false;

          this.onPageHide = this.stopTimer.bind(this);
          this.onPageShow = this.resume.bind(this);
          this.onVisibilityChange = this.handleVisibilityChange.bind(this);

          window.addEventListener('pagehide', this.onPageHide, { passive: true });
          window.addEventListener('pageshow', this.onPageShow, { passive: true });
          document.addEventListener('visibilitychange', this.onVisibilityChange);

          this.observeVisibility();
        }

        disconnectedCallback() {
          this.initialized = false;
          this.stopTimer();

          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }

          if (this.onPageHide) {
            window.removeEventListener('pagehide', this.onPageHide);
            window.removeEventListener('pageshow', this.onPageShow);
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
          }
        }

        observeVisibility() {
          var self = this;

          if (!('IntersectionObserver' in window)) {
            this.visible = true;
            this.activate();
            return;
          }

          this.observer = new IntersectionObserver(function (entries) {
            var entry = entries[0];

            if (!entry) return;

            if (entry.isIntersecting) {
              self.visible = true;
              self.activate();
              return;
            }

            self.visible = false;
            self.stopTimer();
          }, {
            rootMargin: '50px',
            threshold: 0
          });

          this.observer.observe(this);
        }

        activate() {
          if (!this.active) {
            this.active = true;
            this.setCount(this.current);
            this.classList.add(READY_CLASS);
          }

          this.queueUpdate();
        }

        queueUpdate() {
          var self = this;

          if (
            !this.visible ||
            document.hidden ||
            this.timer ||
            this.variation === 0 ||
            this.updates >= this.maxUpdates
          ) {
            return;
          }

          this.timer = window.setTimeout(function () {
            self.timer = 0;

            if (!self.visible || document.hidden) return;

            self.tick();
            self.queueUpdate();
          }, randomInt(this.updateMin, this.updateMax));
        }

        tick() {
          var delta = randomInt(-this.variation, this.variation);
          var next = Math.min(this.max, Math.max(this.min, this.current + delta));

          this.updates += 1;

          if (next === this.current) return;

          this.current = next;
          this.setCount(next);
        }

        setCount(value) {
          var text = String(value);

          if (this.countEl.textContent !== text) {
            this.countEl.textContent = text;
          }
        }

        stopTimer() {
          if (!this.timer) return;

          window.clearTimeout(this.timer);
          this.timer = 0;
        }

        resume() {
          if (this.visible && this.active) {
            this.queueUpdate();
          }
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.stopTimer();
            return;
          }

          this.resume();
        }
      }

      customElements.define(TAG_NAME, LiveViewersCounter);
    }

    afterPageLoad(defineCounter);
  }());

  } catch(e) { console.error(e); }
})();
})();
